import React from 'react'
import './Home.css'
import Header from '../../component/header/Header';
import Programs from '../../component/programs/Programs';
import Values from '../../component/values/values';
import FAQS from '../../component/FAQS/FAQS';
import Testmonial from '../../component/testimonials/Testmonial';
import Footer from '../../component/footer/Footer';


function Home() {
  return (
    <>
      <Header />
      <Programs />
      <Values />
      <FAQS />
      <Testmonial />
      
    </>
  )
}

export default Home